import type { CustomEventsContext } from '../types'

export const TOKEN_ACCESS_DECLINED = 'Token Access Declined'

export default function (this: CustomEventsContext) {
  return this.sendEventWithCallback('push.token', {})
    .then((data: unknown) => {
      const d = data as { token?: string | false }
      if (d.token) {
        return d.token
      }
      return Promise.reject(new Error(
        (d.token === false)
          ? TOKEN_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
